export const UPDATE_PAY_SOURCE = 'UPDATE_PAY_SOURCE';
export const UPDATE_PAYMENT_FORM = 'UPDATE_PAYMENT_FORM';
export const UPDATE_SEND = 'UPDATE_SEND';
export const UPDATE_CARD_TO = 'UPDATE_CARD_TO';
export const UPDATE_CARD_FROM = 'UPDATE_CARD_FROM';
export const UPDATE_ACCOUNT_TO = 'UPDATE_ACCOUNT_TO';
export const UPDATE_ACCOUNT_FROM = 'UPDATE_ACCOUNT_FROM';
export const SET_PRECHECK = 'SET_PRECHECK';
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
export const CHANGE_COUNTRY_MENU = 'CHANGE_COUNTRY_MENU';

export const updatePaymentForm = (paymentForm) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_PAYMENT_FORM,
                paymentForm: paymentForm,
            }),
        );
    };
};
export const setPrecheck = (precheck) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: SET_PRECHECK,
                precheck: precheck,
            }),
        );
    };
};
export const updateSend = (send) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_SEND,
                send: send,
            }),
        );
    };
};
export const setPaymentMethod = (methodName) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: SET_PAYMENT_METHOD,
                method: methodName,
            }),
        );
    };
};

export const updatePaySource = (paySource) => ({
    type: UPDATE_PAY_SOURCE,
    paySource: paySource,
});

export const updateCardTo = (alias, code, paymentSystem, cardLogo, cvvFocus = true) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_CARD_TO,
                alias: alias,
                code: code,
                paymentSystem: paymentSystem,
                cardLogo: cardLogo,
                cvvFocus: cvvFocus,
            }),
        );
    };
};

export const updateCardFrom = (alias, code, paymentSystem, cardLogo, cvvFocus = true) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_CARD_FROM,
                alias: alias,
                code: code,
                paymentSystem: paymentSystem,
                cardLogo: cardLogo,
                cvvFocus: cvvFocus,
            }),
        );
    };
};
export const updateAccountTo = (account) => ({
    type: UPDATE_ACCOUNT_TO,
    account: account,
});
export const updateAccountFrom = (account) => ({
    type: UPDATE_ACCOUNT_FROM,
    account: account,
});
export const updateCountryMenu = (formName, countryMenu) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: CHANGE_COUNTRY_MENU,
                formName: formName,
                countryMenu: countryMenu,
            }),
        );
    };
};
